module.exports = __webpack_public_path__ + "img/Pink.6744c01c.jpg";